// Generated types for FunctionMatchTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityMatchTaskReadAPI, EntityMatchTaskWriteAPI } from './entitymatchtask';
import { EntityMatchTaskReadAPISchemaObject, EntityMatchTaskWriteAPISchemaObject } from './entitymatchtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface FunctionMatchTaskReadAPI extends EntityMatchTaskReadAPI {
}

export interface FunctionMatchTaskWriteAPI extends EntityMatchTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const FunctionMatchTaskReadAPISchema: z.ZodType<FunctionMatchTaskReadAPI> = EntityMatchTaskReadAPISchemaObject.extend({}).passthrough();

export const FunctionMatchTaskWriteAPISchema: z.ZodType<FunctionMatchTaskWriteAPI> = EntityMatchTaskWriteAPISchemaObject.extend({}).passthrough();
